"use client";

import { Plus } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const screenings = [{
  number: "01",
  name: "\nUn premier échange",
  description: " pour définir ensemble les recettes selon vos goûts, votre régime alimentaire et vos besoins. ",
  detail: "Un accompagnement personnalisé pour vous guider dans vos premiers pas de maman, en respectant votre rythme et vos besoins émotionnels et physiques."
}, {
  number: "02",
  name: "Une liste de courses fournie en amont ",
  description: "pour que vous puissiez faire les courses avant ma venue.",
  detail: "Nous préparons ensemble des repas équilibrés et réconfortants, pensés pour favoriser votre récupération et votre vitalité au quotidien."
}, {
  number: "03",
  name: "3 heures de cuisine à domicile",
  description: "où je prépare des plats sains et réconfortants pour votre récupération postnatale.",
  detail: "Rejoignez un groupe bienveillant pour échanger sur vos expériences, vos joies et vos défis dans un cadre sécurisant et sans jugement."
}, {
  number: "04",
  name: "Des plats stockés dans vos contenants",
  description: "prêts à être consommés selon votre rythme.",
  detail: "Accédez à un réseau de professionnels et de mamans pour vous entourer de douceur et de conseils avisés durant cette période de transition."
}, {
  number: "05",
  name: "\nUne cuisine propre et rangée",
  description: "après mon passage, pour un confort optimal.",
  detail: "Un soin traditionnel enveloppant pour honorer votre corps après l'accouchement et vous offrir un moment de reconnexion profonde."
}, {
  number: "06",
  name: "Yum!",
  description: "Vous profitez de repas maison sans effort, en vous concentrant sur votre bien-être et votre bébé.",
  detail: "Discutons ensemble de vos attentes pour construire un accompagnement sur-mesure qui vous ressemble et vous soutient pleinement."
}];
export default function PostnatalServiceDetails() {
  const {
    ref: headerRef,
    isVisible: headerVisible
  } = useRevealOnScroll<HTMLDivElement>();
  return <section data-section-id="3384" id="postnatalservicedetails" className="bg-[#F8F4ED] py-24 md:py-32 lg:py-40 text-[#43362F]">
      <div className="mx-auto max-w-7xl px-6 lg:px-10">
        {}
        <div ref={headerRef} className={`max-w-3xl transition-all duration-1000 ease-out ${headerVisible ? "translate-y-0 opacity-100" : "translate-y-6 opacity-0"}`}>
          <div className="mb-8 flex items-center gap-4">
            <span className="block h-px w-10 bg-[#A77B62]" aria-hidden="true" />
            <span className="font-default text-xs uppercase tracking-[0.2em] text-[#C8735B]">CUISINE POSTNATAL à DOMICILE</span>
          </div>

          <h2 className="font-default text-4xl leading-[1.05] tracking-tight text-[#43362F] sm:text-5xl md:text-6xl lg:text-7xl"><span className="!font-serif" data-ast-id="f:/src/pages/BatchCooking/sections/PostnatalServiceDetails.tsx|sig:2tk5ed" data-ast-start="2859" data-ast-end="2963">Concrétement, mon service de cuisine postnatal à domicile c'est:</span></h2>
        </div>

        {}
        <div className="mt-20 md:mt-28 border-t border-[#D5C3B1]">
          <Accordion type="single" collapsible className="w-full">
            {screenings.map((service, i) => {
            const {
              ref,
              isVisible
            } = useRevealOnScroll<HTMLDivElement>({
              threshold: 0.15
            });
            return <div data-index={i} ref={ref} key={service.number} className={`group/row border-b border-[#D5C3B1] transition-all duration-700 ease-out ${isVisible ? "translate-y-0 opacity-100" : "translate-y-4 opacity-0"}`} style={{
              transitionDelay: `${i * 80}ms`
            }}>
                  <AccordionItem value={service.number} className="border-b-0">
                    <AccordionTrigger className="group/trigger w-full px-2 py-12 md:py-16 lg:py-20 transition-colors duration-500 hover:no-underline hover:bg-[#EFE6DC]/60 rounded-lg [&>svg]:hidden">
                      <div className="grid w-full grid-cols-12 items-center gap-4 md:gap-8 text-left">
                        {}
                        <div className="col-span-2 md:col-span-1">
                          <span className="font-default italic text-2xl md:text-4xl text-[#D5C3B1]">
                            {service.number}
                          </span>
                        </div>

                        {}
                        <div className="col-span-10 md:col-span-5">
                          <h3 className="text-2xl tracking-tight text-[#43362F] transition-colors duration-500 group-hover/trigger:text-[#A77B62] !font-sans md:text-3xl lg:text-4xl">
                            {service.name}
                          </h3>
                        </div>

                        {}
                        <div className="col-span-10 col-start-3 md:col-span-5 md:col-start-auto">
                          <p className="text-sm md:text-base text-[#43362F]/70 leading-relaxed">
                            {service.description}
                          </p>
                        </div>

                        {}
                        <div className="col-span-12 md:col-span-1 flex justify-end">
                          <span className="inline-flex h-10 w-10 items-center justify-center rounded-lg border border-[#D5C3B1] text-[#43362F] transition-all duration-500 group-hover/trigger:border-[#A77B62] group-hover/trigger:text-[#A77B62] group-data-[state=open]/trigger:rotate-45">
                            <Plus className="h-4 w-4" strokeWidth={1.5} />
                          </span>
                        </div>
                      </div>
                    </AccordionTrigger>

                    <AccordionContent className="px-2 pb-12 md:pb-16">
                      <div className="grid grid-cols-12 gap-4 md:gap-8">
                        <div className="col-span-12 md:col-span-6 md:col-start-7">
                          <p className="font-default text-lg md:text-xl leading-relaxed text-[#43362F]/80 mb-6">
                            {service.detail}
                          </p>
                          <Link to="/ContactPage" className="inline-flex items-center gap-2 text-sm text-[#C8735B] transition-colors hover:text-[#A77B62]">
                            <span className="font-default uppercase tracking-[0.15em] text-xs">
                              Réserver cet accompagnement
                            </span>
                            <span className="block h-px w-6 bg-[#C8735B] transition-all group-hover:w-10" aria-hidden="true" />
                          </Link>
                        </div>
                      </div>
                    </AccordionContent>
                  </AccordionItem>
                </div>;
          })}
          </Accordion>
        </div>

        {}
        
      </div>
    </section>;
}